import React, { useCallback } from 'react';
import { isQAActive } from '../../../../../data/filters/questions/isQAActive';
import Link from '../../../Link';
import Icon from '../../../icons/Icon';
import NotificationsBubble from '../../../NotificationsBubble';
import { useEventNotifications } from '../../../../../data/hooks/notifications/useEventNotifications';
import { isNotificationUnread } from '../../../../../data/filters/notifications/isNotificationUnread';
import { isQANewAnswerNotification } from '../../../../../data/filters/notifications/isQANewAnswerNotification';
import { isQANotification } from '../../../../../data/filters/notifications/isQANotification';
import { useUnreadQuestionsCount } from '../../../../../data/hooks/questions/useUnreadQuestionsCount';

function QAIcon(props) {
    const { event, isActive } = props,
        newAnswerNotifications = useEventNotifications(event.id, {
            filter: useCallback((notification) => isNotificationUnread(notification) && isQANewAnswerNotification(notification)),
        }).length,
        newQuestionNotifications = useUnreadQuestionsCount(event.id);

    if (!isQAActive(event)) return null;

    return (
        <Link href={'/events/' + event.id + '/qa'} key="qa">
            <Icon icon="event-qa" selected={isActive}>
                <NotificationsBubble>{newAnswerNotifications + newQuestionNotifications}</NotificationsBubble>
            </Icon>
        </Link>
    );
}

export default QAIcon;
